import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { HashRouter, BrowserRouter } from 'react-router-dom';
import { App } from './App';
render(<BrowserRouter data-id="element-946">
    <App data-id="element-947" />
  </BrowserRouter>, document.getElementById('root'));